<template>
  <div class="pa-0" style="height: 584px;">
  	<div v-if="active">
  		<player :uuid="id" style="width: 60%;"></player>
  	</div>
	</div>
</template>

<script>
import Player from '../Player.vue'

export default {
	props: ["id"],
  components: {
  	Player
  },
  data () {
    return {
      active: this.$route.query.tab == "watch"
    }
  },
  watch: {
    "$route.query.tab" (newVal) {
      if(newVal == "watch") {
        setTimeout(() => {
          this.active = true;
        },200);
      }
    }
  }
}
</script>
